import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

import { formatDateMmDdYyyy } from '../../../utils';

export const LastReceived = ({ lastReceived }) =>
  lastReceived ? <>{formatDateMmDdYyyy(lastReceived)}</> : <Chip label="No Media Received" />;

LastReceived.propTypes = {
  lastReceived: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default LastReceived;



// WEBPACK FOOTER //
// ./src/vp-ui/components/LastReceived/LastReceived.jsx